import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepEquipo from "../../FormularioPropuestaV2/steps/StepEquipo";

const SeccionEquipo = ({ formik, faltantes }) => (
  <SeccionWrapper
    id="seccion-equipo"
    numero={6}
    titulo="Equipo de trabajo"
    faltantes={faltantes}
  >
    <StepEquipo formik={formik} />
  </SeccionWrapper>
);

SeccionEquipo.propTypes = {
  formik: PropTypes.object.isRequired,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionEquipo;
